<template>
    <v-group :config="groupConfig">
        <v-group :config="textGroupConfig">
            <v-text :config="textConfig"></v-text>
        </v-group>
    </v-group>
</template>

<script>
    export default {
        name: "AngleSize",

        props: [
            'angleSize',
            'angleDirectionStart',
        ],

        computed: {
            littleAngle() {
                return this.angleSize <= 40;
            },

            groupConfig() {
                let rotation = this.littleAngle ? 180 : 0;

                return {
                    rotation,
                }
            },

            // use the textGroup to set text position taking into account current rotation
            textGroupConfig() {
                return {
                    offsetX: -2, // this option change the distance from the angle text to the angle center
                    offsetY: 7, // set half of the text height
                    rotation: this.angleSize / 2,
                }
            },

            textConfig() {
                let angleText = this.angleSize.toString() + '°';

                // to set horizontal position of the text
                let rotation = -this.angleDirectionStart - (this.angleSize / 2);

                if (this.littleAngle) {
                    // rotate text back
                    rotation += 180;
                }

                return {
                    x: 20, // repeat the offsetX
                    y: 7, // repeat the offsetY
                    text: angleText,
                    fontSize: 14,
                    fontFamily: 'Arial',
                    fill: 'black',
                    width: 40,
                    align: 'center',
                    rotation, 
                    // the offset use for set the rotation center. for that the "x" and "y" must repeat them
                    offsetX: 18, // set half of the text width
                    offsetY: 7, // set half of the text height
                    // use text shadow to make contrast on the dark background, e.g. dark paint brush
                    shadowColor: 'white',
                    shadowOffset: { x: 1, y: 1 },
                    shadowOpacity: 0.3,
                }
            },

        },

    }
</script>

<style scoped>

</style>